import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { deserializer } from '@shared/helpers/deserializer.helper';
import { errorHandler } from '@shared/helpers/handle-error.helper';
import { IAssetCategory } from '@shared/interfaces/asset-category.interface';
import { IPaginable } from '@shared/interfaces/paginable.interface';
import { AssetCategory } from '@shared/models/asset-category.model';
import { AssetsCategorySerializer } from '@shared/serializers/assets-category.serializer';
import { CommonEnvironmentsService } from '@shared/services/environments.service';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AssetCategorysService implements IPaginable {
  private readonly endpoint: string = String(
    `${this._commonEnvironments.API_ENDPOINT}/asset-categories`
  );

  constructor(
    private readonly _commonEnvironments: CommonEnvironmentsService,
    private readonly _http: HttpClient
  ) {}

  public delete(id: string): Observable<IAssetCategory> {
    return this._http.delete(`${this.endpoint}/${id}`).pipe(
      map((res: any) => new AssetCategory(deserializer.deserialize(res))),
      catchError(errorHandler)
    );
  }

  public find(id: string): Observable<IAssetCategory> {
    return this._http.get(`${this.endpoint}/${id}`).pipe(
      map((res: any) => new AssetCategory(deserializer.deserialize(res))),
      catchError(errorHandler)
    );
  }

  public get(
    pageNumber?: number,
    filters?: any,
    onGetRawData?: (data: any) => void
  ): Observable<IAssetCategory[]> {
    let httpParams = new HttpParams();

    if (pageNumber) {
      httpParams = httpParams.set('page[number]', String(pageNumber));
    }

    if (filters) {
      filters.map((f) => {
        if (f.value) {
          httpParams = httpParams.append(f.key, f.value);
        }
      });
    }

    return this._http.get(this.endpoint, { params: httpParams }).pipe(
      tap((data: any) => onGetRawData && onGetRawData(data)),
      map((res: any) =>
        deserializer.deserialize(res).map((a: IAssetCategory) => new AssetCategory(a))
      ),
      catchError(errorHandler)
    );
  }

  public patch(a: Partial<IAssetCategory>): Observable<IAssetCategory> {
    const data = AssetsCategorySerializer.serialize({
      ...a
    });

    return this._http.patch(`${this.endpoint}/${a.id}`, data).pipe(
      map((res: any) => new AssetCategory(deserializer.deserialize(res))),
      catchError(errorHandler)
    );
  }

  public post(a: IAssetCategory): Observable<IAssetCategory> {
    const data = AssetsCategorySerializer.serialize(a);
    return this._http.post(this.endpoint, data).pipe(
      map((res: any) => new AssetCategory(deserializer.deserialize(res))),
      catchError(errorHandler)
    );
  }
}

